import { BrowserUtility } from "../utilities";
import { LoggerFactory } from "../utilities/logger";

export class WindowCloser {
  static closeConfirmation: () => Promise<boolean> = async () => true;
  static closeHandler: () => Promise<void> = async () => {};
  static registerDocumentAsTemporaryBeforeCloseHandler: (isForcibly: boolean) => Promise<void> = async (isForcibly: boolean) => {};

  static closeSelf(): void {
    // javascriptからの自WindowCloseは、各ブラウザ小細工しないと動かないので基本使わない事!
    // セキュリティ対策としてwindow.close()は自Windowに対しては効かない.
    // 下記実装はメジャーなHackだが、IEはこれで閉じたがchromeは自分の親がいない場合はこれでも閉じない.
    // ただし、下記コマンドラインで起動した場合は閉じられた.(appモードだから？)
    // chrome.exe -app=http://localhost:8080
    // 利用シーンを限定して利用する事.
    if (BrowserUtility.isChromiumBrowser()) {
      this._logger.info("chromium系ブラウザではappモードのみ自画面がクローズできます");
    }
    window.onbeforeunload = null;
    window.open("about:blank", "_self").close();
  }

  static shouldConfirmToClose(): boolean {
    // 編集中は閉じる確認ダイアログが設定されている
    // 閉じる確認ダイアログを設定しているとprototype===undefinedになる
    return this.closeConfirmation.prototype === undefined;
  }

  private static readonly _logger = LoggerFactory.getLogger();
}
